import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { App } from '@df/core/app';
import { StoreCreditService } from './store-credit.service';

@Injectable({
    providedIn: 'root'
})
export class StoreCreditAccountResolver implements Resolve<void> {
    constructor(protected storeCredit: StoreCreditService, protected app: App) {}

    resolve(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.app.customer.model
                .load()
                .then(() => {
                    if (this.storeCredit.displayAccount) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch(reject);
        });
    }
}
